import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../../Components/clubDashboard/Header/Header";
import combinedServices from "../../shared/services/user-service";
import SelectSearch, { fuzzySearch } from 'react-select-search';
import { Country, State, City } from "country-state-city";
import Swal from "sweetalert2";
import getLocalData from "../../shared/localStorage/getData";

const EditClubDetail = () => {
    const { clubId } = useParams();
    const [clubData, setClubData] = useState(null);
    const [users, setUsers] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        club_website: '',
        club_contact_address: '',
        club_contact_address2: '',
        club_country: '',
        club_state: '',
        club_city: '',
        club_zip: '',
        club_district: '',
        club_meets_on_day: '',
        club_meets_on_time: '',
        club_meets_on_time_am_pm: 'AM',
        club_contact_areacode: '+1',
        club_contact_phone: '',
        club_contact_userid_fkey: '',
        club_commodore_userid_fkey: '',
        club_vicecommodore_userid_fkey: '',
        club_secretary_userid_fkey: '',
        club_purser_userid_fkey: '',
        club_status: '',
        club_info: ''
    });
    const [cp, setCp] = useState("");
    const [commodore, setCommodore] = useState("");
    const [vice_commodore, setViceCommodore] = useState("");
    const [secretary, setSecretary] = useState("");
    const [purser, setPurser] = useState("");
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState("");
    const [selectedCountry1, setSelectedCountry1] = useState("");
    const [states, setStates] = useState([]);
    const [selectedState, setSelectedState] = useState("");
    const [selectedState1, setSelectedState1] = useState("");
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState("");
    const [countryiso, setCountryiso] = useState("");

    useEffect(() => {
        fetchClubData();
        fetchUsers();
        fetchDistricts();
    }, [clubId]);

    const fetchClubData = async () => {
        try {
            let userId = "";
            if (getLocalData("user_info", "isLogin")) {
              userId = getLocalData("user_info", "all").userData.login_user_detail.data.user.id;
            }
            const response = await combinedServices.getClubById({ club_id: clubId });
            if (response.status === 200) {
                if(response.data.club_founder_userid_fkey!=userId){
                    Swal.fire("Unauthorized", "You are not authorized to edit this club.", "error").then(()=>{
                        window.location.href = "/";
                    })
                }
                setClubData(response.data);
                console.log("club data is", response.data);
                setFormData({
                    club_website: response.data.club_website || '',
                    club_contact_address: response.data.club_contact_address || '',
                    club_contact_address2: response.data.club_contact_address2 || '',
                    club_country: response.data.club_country || '',
                    club_state: response.data.club_state || '',
                    club_city: response.data.club_city || '',
                    club_zip: response.data.club_zip || '',
                    club_district: response.data.club_district || '',
                    club_meets_on_day: response.data.club_meets_on_day || '',
                    club_meets_on_time: response.data.club_meets_on_time || '',
                    club_meets_on_time_am_pm: response.data.club_meets_on_time_am_pm || 'AM',
                    club_contact_areacode: response.data.club_contact_areacode || '+1',
                    club_contact_phone: response.data.club_contact_phone || '',
                    club_contact_userid_fkey: response.data.club_contact_userid_fkey || '',
                    club_commodore_userid_fkey: response.data.club_commodore_userid_fkey || '',
                    club_vicecommodore_userid_fkey: response.data.club_vicecommodore_userid_fkey || '',
                    club_secretary_userid_fkey: response.data.club_secretary_userid_fkey || '',
                    club_purser_userid_fkey: response.data.club_purser_userid_fkey || '',
                    club_status: response.data.club_status || '',
                    club_info: response.data.club_info || ''
                });
                setSelectedCountry1(response?.data?.club_country);
                setSelectedState1(response?.data?.club_state);
                setSelectedCity(response?.data?.club_city);
                const allCountries = Country.getAllCountries();
                setCountries(allCountries);
            }
        } catch (error) {
            console.error("Error fetching club data:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchUsers = async () => {
        try {
            const response = await combinedServices.getAllUser();
            var userArr = [] ;
            response?.data.map((user)=>{

                var data = {
                    name : user.user_firstname+" "+user.user_lastname ,
                    value : user.id


                }
                userArr.push(data)
            
            })

            setUsers(userArr) ;
            // if (response.status === 200) {
            //     setUsers(response.data);
            // }
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    const fetchDistricts = async () => {
        try {
            const response = await combinedServices.getAllDistric();
            if (response.status === 200) {
                setDistricts(response.data);
            }
        } catch (error) {
            console.error("Error fetching districts:", error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const getUserById = (userId) => {
        return users.find(user => user.value === parseInt(userId));
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    const handleSearchBox_cp = (e) => {
        setCp(e);
        setFormData({...formData, club_contact_userid_fkey: e});
    }

    const handleSearchBox_commodore =  (e) => {
        setCommodore(e);
        setFormData({...formData, club_commodore_userid_fkey: e});
    }

    const handleSearchBox_vice_commodore = (e) => {
        setViceCommodore(e);
        setFormData({...formData, club_vicecommodore_userid_fkey: e});
    }

    const handleSearchBox_secretary = (e) => {
        setSecretary(e);
        setFormData({...formData, club_secretary_userid_fkey: e});
    }

    const handleSearchBox_purser = (e) => {
        setPurser(e);
        setFormData({...formData, club_purser_userid_fkey: e});
    }

    const handleCountry = (isoCode) => {
        console.log("country isoCode is", isoCode);
        const country = countries.find((c) => c.isoCode === isoCode);
        setSelectedCountry({
          // isoCode,
          name: country.name,
        });
        setSelectedCountry1(selectedCountry.name);
        setFormData(prev => ({...prev, club_country: country.name}));
        const allstate = State.getAllStates();
        const stater = allstate.filter((x) => x.countryCode === isoCode);
        setCountryiso(isoCode);
        setStates(stater);
    };
    
    const handleState = (isoCode) => {
        console.log("state isoCode is", isoCode);
        const state = states.find((state) => state.isoCode === isoCode);
        setSelectedState({
            // isoCode,
            name: state.name,
        });
        setSelectedState1(selectedState.name);
        setFormData(prev => ({...prev, club_state: state.name}));
        const allcities = City.getAllCities();
        const cities = allcities.filter(
            (x) => x.stateCode == isoCode && x.countryCode == countryiso
        );
        setCities(cities);
    };
    
    const handleCity = (val) => {
        setSelectedCity(val);
        setFormData({...formData, club_city: val});
    };

    const handleUpdateClick = async () => {
        try {
            const response = await combinedServices.updateClubDetails({clubId, ...formData});
            console.log("update club response is", response);
            if(response.status==200){
                //Display a sweet alert that updation was successfull
                Swal.fire("Updated!", "Club has been updated.", "success");
            } else {
                Swal.fire("Error!", "Failed to update club.", "error");
            }
        } catch (error) {
            console.log("Error updating club:", error);
            Swal.fire("Error!", "Failed to update club.", "error");
        }
    }

    return (
        <>
            <Header/>
            <div className="dbRight">
            <div className="dbMid dbInner">
                <div className="flexBox spacebetween topHdBox">
                    <div className="left ecTop">
                        <div className="dbMainHd">Edit Club "{clubData?.club_name}"</div>
                        <div className="text">You are the registrar of this club. <span className="blueClr">Registrar</span> on:
                            {clubData?.club_foundedon && new Date(clubData.club_foundedon).toLocaleDateString()}</div>
                    </div>
                </div>
                <div className="dbWhtBox">
                    <div className="fieldHd mb30">Proposed Name of the Club (Please write to NAMBA, if you need to change the name of your club)</div>
                    <ul className="flexBox editForm">
                        <li>
                            <span className="fieldHd">Website Url</span>
                            <input type="text" name="club_website" className="formInput" placeholder="Enter Website Url" value={formData.club_website} onChange={handleInputChange} />
                        </li>
                        <li>
                            <span className="fieldHd">Street Address Line 1</span>
                            <input type="text" name="club_contact_address" className="formInput" placeholder="Enter Street Address Line 1" value={formData.club_contact_address} onChange={handleInputChange} />
                        </li>
                        <li>
                            <span className="fieldHd">Address Line 2 (optional)</span>
                            <input type="text" name="club_contact_address2" className="formInput" placeholder="Enter Address Line 2 (optional)" value={formData.club_contact_address2} onChange={handleInputChange} />
                        </li>
                        <li>
                            <span className="fieldHd">Country</span>
                            {/* <select className="formSelect" name="club_country" value={formData.club_country} onChange={handleInputChange}>
                                <option value="">Select Country</option>
                                {countries.map(country => (
                                    <option key={country} value={country}>{country}</option>
                                ))}
                            </select> */}
                            <select
                                onChange={(e) => handleCountry(e.target.value)}
                                value={selectedCountry.isoCode}
                                className="formSelect"
                            >
                            <option value="">
                                {" "}
                                {typeof selectedCountry == "string"
                                ? selectedCountry1
                                : "Select Country"}
                            </option>
                            {countries.map((country) => (
                                <option key={country.isoCode} value={country.isoCode}>
                                {country.name}
                                </option>
                            ))}
                            </select>
                        </li>
                        <li>
                            <span className="fieldHd">State</span>
                            {/* <input type="text" name="club_state" className="formInput" placeholder="Enter State" value={formData.club_state} onChange={handleInputChange} /> */}
                            <select
                                onChange={(e) => handleState(e.target.value)}
                                value={selectedState.isoCode}
                                className="formSelect"
                            >
                                <option value="">
                                    {" "}
                                    {typeof selectedState == "string"
                                    ? selectedState1
                                    : "Select State"}
                                </option>

                                {states.map((state) => (
                                    <option key={state.isoCode} value={state.isoCode}>
                                    {state.name}
                                    </option>
                                ))}
                            </select>
                        </li>
                        <li>
                            <span className="fieldHd">City</span>
                            {/* <input type="text" name="club_city" className="formInput" placeholder="Enter City" value={formData.club_city} onChange={handleInputChange} /> */}
                            <select
                                onChange={(e) => handleCity(e.target.value)}
                                value={selectedCity}
                                className="formSelect"
                            >
                                <option value="">
                                    {" "}
                                    {typeof selectedCity == "string"
                                    ? selectedCity
                                    : "Select City"}
                                </option>
                                {/* <option value="">Select City</option> */}
                                {cities.map((city) => (
                                    <option key={city.name} value={city.name}>
                                    {city.name}
                                    </option>
                                ))}
                            </select>
                        </li>
                        <li>
                            <span className="fieldHd">Zip</span>
                            <input type="text" name="club_zip" className="formInput" placeholder="Enter Zip" value={formData.club_zip} onChange={handleInputChange} />
                        </li>
                        <li>
                            <span className="fieldHd">District</span>
                            <select className="formSelect" name="club_district" value={Number(formData.club_district)} onChange={handleInputChange}>
                                <option value="">Select District</option>
                                {districts.map(district => (
                                    <option key={district.district_id} value={district.district_id}>{district.district_id}</option>
                                ))}
                            </select>
                        </li>
                        <li>
                            <span className="fieldHd">Club Status</span>
                            <select className="formSelect" name="club_status" value={formData.club_status} onChange={handleInputChange}>
                                <option value="">Select Status</option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </select>
                        </li>
                    </ul>
                    <ul className="flexBox editForm">
                        <li>
                            <span className="fieldHd">Club Meets On Day:</span>
                            <div className="pr">
                                <input type="text" name="club_meets_on_day" className="formInput datepicker" placeholder="Enter Date" value={formData.club_meets_on_day} onChange={handleInputChange} />
                                <span className="material-icons dateIcon" translate='no'>today</span>
                            </div>
                        </li>
                        <li>
                            <span className="fieldHd">Club Meets On Time:</span>
                            <div className="pr">
                                <input type="text" name="club_meets_on_time" className="formInput timepicker" placeholder="Enter Time" value={formData.club_meets_on_time} onChange={handleInputChange} />
                                <span className="material-icons dateIcon" translate='no'>schedule</span>
                            </div>
                        </li>
                        <li>
                            <span className="fieldHd">AM/PM</span>
                            <select className="formSelect" name="club_meets_on_time_am_pm" value={formData.club_meets_on_time_am_pm} onChange={handleInputChange}>
                                <option value="AM">AM</option>
                                <option value="PM">PM</option>
                            </select>
                        </li>
                        <li>
                            <span className="fieldHd">Contact Phone:</span>
                            <div className="phoneBox">
                                <select className="formSelect codeSelect" name="club_contact_areacode" value={formData.club_contact_areacode} onChange={handleInputChange}>
                                    <option value="+1">+1</option>
                                    <option value="+91">+91</option>
                                </select>
                                <input type="text" name="club_contact_phone" className="formInput" placeholder="Enter Phone Number" value={formData.club_contact_phone} onChange={handleInputChange} />
                            </div>
                        </li>
                    </ul>
                    <ul className="flexBox editForm">
                        <li>
                            <span className="fieldHd">Contact Person:</span>
                            <div className="flexBox nowrap itemTop">
                                <SelectSearch
                                    options={users}
                                    value={cp}
                                    
                                    onChange={handleSearchBox_cp}
                                    search
                                    filterOptions={fuzzySearch}
                                    placeholder="Search something"
                                    className="select-search"
                                />
                                {formData.club_contact_userid_fkey && (
                                    <div className="profileInfo" style={{marginTop: '8px'}}>
                                        <span className="hd">
                                            <span className="material-icons icon" translate='no'>check_circle_outline</span> 
                                            {getUserById(formData.club_contact_userid_fkey)?.name}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </li>
                        <li>
                            <span className="fieldHd">Commodore:</span>
                            <div className="flexBox nowrap itemTop">
                                <SelectSearch
                                    options={users}
                                    value={commodore}
                                    
                                    onChange={handleSearchBox_commodore}
                                    search
                                    filterOptions={fuzzySearch}
                                    placeholder="Search something"
                                    className="select-search"
                                />
                                {formData.club_commodore_userid_fkey && (
                                    <div className="profileInfo" style={{marginTop: '8px'}}>
                                        <span className="hd">
                                            <span className="material-icons icon" translate='no'>check_circle_outline</span> 
                                            {getUserById(formData.club_commodore_userid_fkey)?.name} 
                                        </span>
                                    </div>
                                )}
                            </div>
                        </li>
                        <li>
                            <span className="fieldHd">Vice-Commodore:</span>
                            <div className="flexBox nowrap itemTop">
                                <SelectSearch
                                    options={users}
                                    value={vice_commodore}
                                    
                                    onChange={handleSearchBox_vice_commodore}
                                    search
                                    filterOptions={fuzzySearch}
                                    placeholder="Search something"
                                    className="select-search"
                                />
                                {formData.club_vicecommodore_userid_fkey && (
                                    <div className="profileInfo" style={{marginTop: '8px'}}>
                                        <span className="hd">
                                            <span className="material-icons icon" translate='no'>check_circle_outline</span> 
                                            {getUserById(formData.club_vicecommodore_userid_fkey)?.name}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </li>
                        <li>
                            <span className="fieldHd">Secretary:</span>
                            <div className="flexBox nowrap itemTop">
                                <SelectSearch
                                    options={users}
                                    value={secretary}
                                    
                                    onChange={handleSearchBox_secretary}
                                    search
                                    filterOptions={fuzzySearch}
                                    placeholder="Search something"
                                    className="select-search"
                                />
                                {formData.club_secretary_userid_fkey && (
                                    <div className="profileInfo" style={{marginTop: '8px'}}>
                                        <span className="hd">
                                            <span className="material-icons icon" translate='no'>check_circle_outline</span> 
                                            {getUserById(formData.club_secretary_userid_fkey)?.name}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </li>
                        <li>
                            <span className="fieldHd">Purser:</span>
                            <div className="flexBox nowrap itemTop">
                                <SelectSearch
                                    options={users}
                                    value={purser}
                                    
                                    onChange={handleSearchBox_purser}
                                    search
                                    filterOptions={fuzzySearch}
                                    placeholder="Search something"
                                    className="select-search"
                                />
                                {formData.club_purser_userid_fkey && (
                                    <div className="profileInfo" style={{marginTop: '8px'}}>
                                        <span className="hd">
                                            <span className="material-icons icon" translate='no'>check_circle_outline</span> 
                                            {getUserById(formData.club_purser_userid_fkey)?.name}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </li>
                    </ul>
                    <ul className="flexBox editForm">
                        <li className="full">
                            <span className="fieldHd">Club Information (optional):</span>
                            <textarea rows="5" cols="5" name="club_info" className="formInput" placeholder="Enter Club Information" value={formData.club_info} onChange={handleInputChange}></textarea>
                        </li>
                    </ul>
                    <div>
                        <button
                            className="formBtn"
                            type="button"
                            onClick={handleUpdateClick}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
            </div>
        </>
    );
}

export default EditClubDetail;